module.exports = __webpack_public_path__ + "media/images/prediction/special/nagai/arrow_caption-3cb984eb27c811bcd73cfee9733bcb3f.gif";